export default "__VITE_ASSET__DNcp0$oA__"